import React from 'react';
import { Box } from '@mui/material';
import { LoadingButton } from '../../components';

interface FormActionsProps {
  nextButtonText?: string;
  previousButtonText?: string;
  nextButtonType?: 'submit' | 'button';
  nextButtonDisabled?: boolean;
  loading?: boolean;
  onNext: () => void;
  onPrevious?: () => void;
}

const FormActions: React.FC<FormActionsProps> = ({
  onNext,
  onPrevious,
  loading,
  nextButtonText,
  previousButtonText,
  nextButtonType = 'button',
  nextButtonDisabled,
}) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2, gap: 1 }}>
    {onPrevious && (
      <LoadingButton variant="outlined" loading={loading} disabled={loading} onClick={onPrevious}>
        {previousButtonText || 'กลับ'}
      </LoadingButton>
    )}
    <LoadingButton
      type={nextButtonType}
      variant="contained"
      loading={loading}
      disabled={loading || nextButtonDisabled}
      onClick={onNext}
      sx={{ width: '100%' }}
    >
      {nextButtonText || 'ถัดไป'}
    </LoadingButton>
  </Box>
);

export default FormActions;
